<template>
    <modal name="create-album" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'create-album', 'balance-in-modal', hasBugs && 'has-bugs']" :width="730"
        :height="'auto'" :adaptive="true">
        <div class="modal-title">
            {{ $t("albums.createAlbum") }}
            <span v-if="isVideo">
                {{ $t("albums.video") }}
            </span>
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="form-group avatar-group">
                <label for="avatar" class="label">
                    {{ $t("photos.albumCover") }}
                </label>
                <div class="avatar-preview-wrapper">
                    <input type="file" accept="image/*" id="avatar" name="avatar" @change="addImage($event, 'avatar')"
                        v-validate.persist="'size:10000|ext:jpeg,jpg,png,gif'" data-vv-as="file" class="input-hidden">
                    <div :style="{
                        'background-image':
                            avatar &&
                                !errors.has('avatar') ?
                                'url(' + avatar + ')' :
                                ''
                    }" class="image-preview" :class="{
    'no-image': !avatar ||
        errors.has('avatar')
}">
                        <div v-if="avatar" class="delete-image" @click="deleteImage('avatar')"></div>
                        <label for="avatar" class="change-avatar">
                            {{ $t("albumEdit.change") }}
                        </label>
                    </div>
                </div>
                <div class="v-error label-tip">{{ errors.first('avatar') }}</div>
            </div>
            <div class="form-group">
                <label for="title" class="label">
                    {{ $t("albumEdit.albumTitle") }}
                </label>
                <input id="title" type="text" name="title" v-model="title" v-validate.persist="'required'" :maxlength="30"
                    class="input" :class="{ 'field-error': errors.has('title') }">
                <div class="v-error label-tip">{{ errors.first('title') }}</div>
            </div>
            <div class="form-group">
                <label for="description" class="label">
                    {{ $t("albumEdit.description") }}
                </label>
                <textarea id="description" v-model="description" class="textarea"></textarea>
            </div>

            <div class="buttons-row">
                <button @click="close" type="button" class="button-secondary">{{ $t("albumEdit.cancel") }}</button>
                <button @click="create" v-if="!loader" class="button">{{ $t("albums.createAlbum") }}</button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </modal>
</template>

<script>
import { uploadImage } from '@/mixins/uploadImage';
import { localizeValidation } from '@/mixins/localizeValidation';
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'CreateAlbum',
    props: {
        i18n: Object,
    },
    mixins: [
        uploadImage,
        localizeValidation,
        checkScroll
    ],
    data() {
        return {
            title: '',
            description: '',
            avatar: '',
            hasBugs: false,
            loader: false,
            isVideo: false
        }
    },
    computed: {
        albumsErrors() {
            return this.$store.getters[(this.isVideo ? 'videoAlbums' : 'albums') + '/errors']
        }
    },
    watch: {
        '$route'(to, from) {
            if (to != from) {
                this.$modal.hide('create-album');
            }
        }
    },
    methods: {
        beforeOpen(event) {
            this.localizeValidation();
            this.checkScroll();
            this.isVideo = event.params && event.params.isVideo || false;
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        create() {
            this.$validator.validateAll()
                .then((valid) => {
                    if (valid) {
                        this.loader = true;
                        const data = {
                            title: this.title
                        };
                        if (this.description) {
                            data.description = this.description;
                        };
                        if (this.avatar) {
                            data.avatar = this.avatar;
                        };
                        this.$store.dispatch((this.isVideo ? 'videoAlbums' : 'albums') + '/create', data)
                            .then(() => {
                                this.loader = false;
                                this.title = '';
                                this.description = '';
                                this.avatar = '';
                                document.getElementById('avatar').value = '';
                                this.errors.clear();
                                this.$validator.reset();
                                this.$modal.hide('create-album');
                            })
                            .catch(() => {
                                this.loader = false;
                                if (typeof this.albumsErrors === 'object') {
                                    for (let key in this.albumsErrors) {
                                        this.errors.add({
                                            field: key,
                                            msg: this.albumsErrors[key][0]
                                        });
                                    }
                                }

                            })
                    }
                });
        },
        close() {
            this.$modal.hide('create-album');
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/components/_validation';
@import '~@/assets/styles/layout/_create-album';
</style>
